import { API_BASE_URL } from '@/config'
import { createApiError } from '@/helper/apiError.helpers'
import Cookies from 'js-cookie'
import type { GetOrderAttachmentsResponse } from './dto/order.dto'
import { API } from '.'

export function listOrderAttachments(orderId: number) {
  return API<GetOrderAttachmentsResponse>(
    `/orders/${orderId}/attachments`,
    {},
    'Fehler beim Laden der Anhänge',
    'ORDER_ATTACHMENTS_FETCH_ERROR'
  )
}

export async function uploadOrderAttachment(orderId: number, file: File) {
  const form = new FormData()
  form.append('files', file)

  const csrf = localStorage.getItem('CSRF_TOKEN') || Cookies.get('CSRF_TOKEN') || ''

  const res = await fetch(`${API_BASE_URL}/orders/${orderId}/attachments`, {
    method: 'POST',
    body: form,
    credentials: 'include', // IMPORTANT: send cookies (auth + CSRF-cookie)
    headers: {
      // DO NOT set Content-Type, browser sets multipart/form-data automatically
      'X-CSRF-Token': csrf,
      Accept: 'application/json',
    },
  })

  if (!res.ok) {
    // Surface the backend's reason (e.g. INVALID_FILE / ATTACHMENT_LIMIT_EXCEEDED)
    // instead of a generic message, mirroring the shared API() error shape.
    const data = await res.json().catch(() => null)
    throw createApiError({
      message: data?.message || 'Fehler beim Hochladen des Anhangs',
      code: data?.code || 'ORDER_ATTACHMENT_UPLOAD_ERROR',
      errors: data?.errors,
      status: res.status,
      data,
      fileName: file.name,
    })
  }

  return await listOrderAttachments(orderId)
}

export async function deleteOrderAttachment(orderId: number, attachmentId: number) {
  await API(
    `/orders/${orderId}/attachments/${attachmentId}`,
    {
      method: 'DELETE',
    },
    'Fehler beim Löschen des Anhangs',
    'ORDER_ATTACHMENT_DELETE_ERROR'
  )

  return await listOrderAttachments(orderId)
}
